<template>
<div class="container">
<div class="modal-dialog ">
      
      <div class="modal-content">
            <div class="modal-header">
                    <h2><strong>404 Page not found <i class="fa fa-meh-o"/> </strong></h2>
            </div>
            <div class="modal-body" >
                  <div class="row">
                        <div class="col-xs-12 col-sm-12" >
                              <div class="well" style="margin-bottom:5px;">
                                    
                                    <h2> Oops the page requested was not Found</h2>      
                              </div>
                                
                        <br>       
                        </div>
                        
                        <a href="javascript:;" @click="goBack()"><h3 class="text-center">Take me Home</h3></a>
                  </div>
                  
            </div>
            
      </div>
     

  
</div>
</div>
</template>
<script>

import router from '../../router'

 export default {
    name: 'notfound',
    data() {
          return {

          }
    },
    methods:{
      goBack(){
            router.push({path: '/'})
      }
   }
 }
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// NotFound.vue?5936cd58